import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import MutateDocumentDialog, { DocumentMutationAction } from '../../Dialog/MutateDocument/MutateDocumentDialog'
import { CommandBarButton } from '@fluentui/react'
import { IDocumentStackItemDto } from '../../../config/documentConfig'
import DialogButton from '../../Button/DialogButton'
import { DocumentCommandBarItemProps, overflowButtonStyles, visibleButtonStyles } from './DocumentCommandBar'
import { useTranslation } from 'react-i18next'

type Props = DocumentCommandBarItemProps & {
    action: DocumentMutationAction
}

export default function MutateDocumentButton(props: Props): ReactElement {
    const { t: translate } = useTranslation()

    const iconName = useMemo(
        () =>
            new Map([
                [DocumentMutationAction.Rename, 'Rename'],
                [DocumentMutationAction.Copy, 'Copy'],
                [DocumentMutationAction.Move, 'FabricMovetoFolder'],
            ]).get(props.action),
        [props.action],
    )
    return (
        <DialogButton
            button={CommandBarButton}
            buttonProps={{
                text: translate(`file.pivot.document.mutate.${props.action.toLowerCase()}.button`),
                disabled: props.isLoading,
                iconProps: { iconName },
                styles: props.item.renderedInOverflow ? overflowButtonStyles : visibleButtonStyles,
            }}
            dialog={MutateDocumentDialog}
            dialogProps={{
                dialogContentProps: {
                    title: translate(`file.pivot.document.mutate.${props.action.toLowerCase()}.title.${props.selectionType.toLowerCase()}`),
                },
                action: props.action,
                folders: props.rootFolder.data,
                fileReference: props.file.reference,
                selectedItems: props.selectedItems,
                selectionType: props.selectionType,
                reset: (stack?: IDocumentStackItemDto[]) => props.reset(props.sortOrder, stack),
            }}
        />
    )
}
